import type { ConfigIssue } from './catalog/issue';

/**
 * Outcome of a domain operation. Failures carry a typed issue rather than an
 * exception, so a caller cannot forget to handle them and copy stays in the
 * issue catalog.
 */
export type Result<T> =
  | { readonly ok: true; readonly value: T }
  | { readonly ok: false; readonly issue: ConfigIssue };

export const ok = <T>(value: T): Result<T> => ({ ok: true, value });

export const fail = (issue: ConfigIssue): Result<never> => ({ ok: false, issue });
